"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapePropertyHsvValueDestination = void 0;
var tslib_1 = require("tslib");
var enums_1 = require("../../../../core/model/themes/enums");
var color_collections_1 = require("../../model/color-collections");
var destination_1 = require("../base/destination");
var destination_type_1 = require("../utils/destination-type");
var ShapePropertyHsvValueDestination = (function (_super) {
    tslib_1.__extends(ShapePropertyHsvValueDestination, _super);
    function ShapePropertyHsvValueDestination(importer, hsvInfo) {
        if (hsvInfo === void 0) { hsvInfo = new color_collections_1.HsvInfo(); }
        var _this = _super.call(this, importer) || this;
        _this.hsvInfo = hsvInfo;
        return _this;
    }
    Object.defineProperty(ShapePropertyHsvValueDestination.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.ShapePropertyHsvValueDestination; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShapePropertyHsvValueDestination.prototype, "controlCharHT", {
        get: function () { return null; },
        enumerable: false,
        configurable: true
    });
    ShapePropertyHsvValueDestination.getThis = function (importer) {
        return importer.destination;
    };
    ShapePropertyHsvValueDestination.onAccentOneKeyword = function (importer, _parameterValue, _hasParameter) {
        ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.schemeColor = enums_1.SchemeColorValues.Accent1;
    };
    ShapePropertyHsvValueDestination.onAccentTwoKeyword = function (importer, _parameterValue, _hasParameter) {
        ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.schemeColor = enums_1.SchemeColorValues.Accent2;
    };
    ShapePropertyHsvValueDestination.onAccentThreeKeyword = function (importer, _parameterValue, _hasParameter) {
        ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.schemeColor = enums_1.SchemeColorValues.Accent3;
    };
    ShapePropertyHsvValueDestination.onAccentFourKeyword = function (importer, _parameterValue, _hasParameter) {
        ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.schemeColor = enums_1.SchemeColorValues.Accent4;
    };
    ShapePropertyHsvValueDestination.onAccentFiveKeyword = function (importer, _parameterValue, _hasParameter) {
        ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.schemeColor = enums_1.SchemeColorValues.Accent5;
    };
    ShapePropertyHsvValueDestination.onAccentSixKeyword = function (importer, _parameterValue, _hasParameter) {
        ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.schemeColor = enums_1.SchemeColorValues.Accent6;
    };
    ShapePropertyHsvValueDestination.onTintKeyword = function (importer, parameterValue, hasParameter) {
        if (hasParameter)
            ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.tint = parameterValue;
    };
    ShapePropertyHsvValueDestination.onShadeKeyword = function (importer, parameterValue, hasParameter) {
        if (hasParameter)
            ShapePropertyHsvValueDestination.getThis(importer).hsvInfo.shade = parameterValue;
    };
    ShapePropertyHsvValueDestination.prototype.createClone = function () {
        return new ShapePropertyHsvValueDestination(this.importer, this.hsvInfo);
    };
    return ShapePropertyHsvValueDestination;
}(destination_1.DestinationBase));
exports.ShapePropertyHsvValueDestination = ShapePropertyHsvValueDestination;
